import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Divider } from "@mui/material";

export default function ExpandableAccordion(props) {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box sx={{ width: "95%", my: 2 }} ml={2}>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        sx={{
          border: "1px solid #DFDFDF",
          borderRadius: "10px",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1bh-content'
          id='panel1bh-header'
          sx={{ py: 1 }}
        >
          {props.icon}
          <Typography
            ml={1}
            sx={{ width: "33%", flexShrink: 0, fontWeight: "bold" }}
          >
            {props.title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Divider />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            {props.content}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
